import styled from 'styled-components'

import breakpoints from '../../constants/ui/breakpoints'

import { Section } from '../PageLayout'

export const AutomationsVideoStyled = styled(Section)`
  .title {
    max-width: 900px;
    margin-bottom: 1.5rem;
  }

  .subtitle {
    max-width: 900px;
    margin-bottom: 1.5rem;
  }

  .btn-group {
    display: flex;
    justify-content: space-between;
    gap: 2rem;
    min-width: 650px;
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;

    @media (max-width: ${breakpoints.screenMD}) {
      gap: 1rem;
      min-width: 580px;

      button {
        min-width: fit-content;
      }
    }

    @media (max-width: ${breakpoints.screenSM}) {
      flex-direction: column;
      min-width: 90%;
      margin-top: 0;

      button {
        width: 100%;
      }
    }
  }

  .automations-group {
    display: flex;
    gap: 2rem;
    width: 100%;
    margin-top: 1.5rem;

    @media (max-width: ${breakpoints.screenSM}) {
      flex-direction: column;
      gap: 3rem;
      margin-top: 0;
    }
  }

  .automations {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 3rem;
    width: calc(50% - 1rem);

    @media (max-width: ${breakpoints.screenSM}) {
      gap: 1.5rem;
      width: 100%;
    }
  }

  .circle {
    position: absolute;
    top: 1.5rem;
    height: 350px;
    width: 350px;
    background-color: ${({ theme }) => theme.backgroundSecondary};
    border-radius: 100%;

    @media (max-width: ${breakpoints.screenMD}) {
      height: 320px;
      width: 320px;
    }
  }

  .video {
    position: relative;
    border-radius: 2rem;
    max-width: 200px;
    height: 408px;
    overflow: hidden;
    z-index: 1;

    video {
      min-width: 204px;
      margin-left: -2px;
    }
  }

  .text {
    max-width: 400px;
  }
`
